module.exports = __webpack_public_path__ + "static/media/bd-enterprise-inventory-infographic.8c286a1f.jpg";